export default {
  amEx: 'icons8-am_ex',
  accounts: 'calculator',
  activity: 'calendar_filled',
  activityEmail: 'icons8-mail_filled',
  activityType: 'calendar_filled',
  activityTask: 'icons8-business_filled',
  activityNote: 'note_filled',
  activityMeeting: 'statistics_filled',
  activityCall: 'phone_filled',
  activityTodo: 'arrow_filled',
  activityResourceType: 'opened_folder',
  activityResource: 'reservation_filled',
  address: 'icons8-address_filled',
  addFromPriceListIcon: 'addfrompricelisticon',
  alert: 'alert',
  add: 'plus',
  addNoMargin: 'plus-no-margin',
  addActivity: 'icons8-calendar_plus_filled',
  addFolder: 'add_folder_filled',
  addSimple: 'icons8-plus_math_filled',
  addTeam: 'icons8-add_user_group',
  addTeamFilled: 'icons8-add_user_group_filled',
  addToRight: 'icons8-double_right',
  approvalApprove: 'approval-approve',
  approvals: 'approvals',
  approvalHistoryCreated: 'approval-history-created',
  approvalHistoryEdit: 'approval-history-edit',
  approvalPlaceholder: 'approval-placeholder-image',
  approvalPreviewEnlarge: 'approval-preview-enlarge',
  approvalReject: 'approval-reject',
  approvalRequestChanges: 'approval-request-changes',
  assemblyIncluded: 'icons8-full_moon_filled',
  assemblyNotIncluded: 'icons8-empty_set_filled',
  attachment: 'icons8-attach',
  automaticReminders: 'alarm',
  back: 'back',
  bankCard: 'icons8-bank_cards',
  breadCrumbCarret: 'icons8-chevron_right_filled',
  bug: 'icons8-spider_filled',
  bullet: 'arrow_filled',
  bullet2: 'arrow',
  businessType: 'building',
  beach: 'beach',
  burgerMenu: 'icons8-menu_filled',
  burgerMenuClose: 'icons8-chevron_left_filled',
  bulkAssign: 'icons8-batch_assign',
  bulkAssignFilled: 'icons8-batch_assign_filled',
  calcWizard: 'calc_wizards',
  campaignActivity: 'icons8-advertising_filled',
  checked: 'icons8-checked_filled',
  clarityPro: 'clarity-pro',
  clear: 'clear',
  close: 'close',
  company: 'office',
  companyStats: 'cheap_2',
  configure: 'horizontal_settings_mixer',
  connected: 'connected',
  contactDetails: 'icons8-details_popup',
  contactDetailsFilled: 'icons8-details_popup_filled',
  contact: 'user',
  contactGroup: 'Contacts',
  contactList: 'people_filled',
  contactListInactive: 'people',
  contactListGroup: 'icons8-open_box',
  contactListGroupFilled: 'icons8-open_box_filled',
  contactMethod: 'icons8-communication_filled',
  contactRoles: 'people_filled',
  contactSearch: 'icons8-find_user',
  createdDate: 'created_date',
  csv: 'icons8-csv_filled',
  copy: 'icons8-copy_filled',
  copyToClipboard: 'copyToClipboard',
  copyLink: 'icons8-link_filled',
  collection: 'icons8-running',
  collectionFilled: 'icons8-running_filled',
  collapse: 'minus_math',
  crm: 'crm',
  cut: 'icons8-cut_filled',
  dashboard: 'dashboard_filled',
  data: 'icons8-database_filled',
  date: 'icons8-calendar_filled',
  dateRange: 'icons8-calendar_filled',
  delete: 'delete_forever_filled',
  delete2: 'delete',
  deleteTeam: 'icons8-remove_user_group_man_man',
  deleteTeamFilled: 'icons8-remove_user_group_man_man_filled',
  delivery: 'truck',
  deliveryReturn: 'replyArrow',
  department: 'department_filled',
  details: 'details_popup_filled',
  disconnected: 'disconnected',
  discount: 'calculator',
  document: 'document_filled',
  dormant: 'icons8-empty_trash',
  download: 'download',
  dropdown: 'icons8-sort_down_filled',
  dropUp: 'icons8-sort_up',
  dropright: 'icons8-sort_right',
  edit: 'icons8-pencil_tip_filled',
  edit2: 'edit',
  editNonFilled: 'icons8-pencil_tip',
  email: 'icons8-mail_filled',
  emailBounced: 'icons8-spam_filled',
  emailClicked: 'icons8-link_filled',
  emailed: 'emailed',
  emailForwarded: 'icons8-forward_arrow_filled',
  emailInvite: 'icons8-invite',
  emailOpened: 'icons8-read_message_filled',
  emailSent: 'icons8-sent_filled',
  emailSkipped: 'icons8-deleted_message',
  emailUnsubscribed: 'icons8-stop_sign_filled',
  enterItem: 'icons8-pencil_tip_filled',
  exitState: 'icons8-exit',
  exitStateFilled: 'icons8-exit_filled',
  enterState: 'icons8-enter_2',
  enterStateFilled: 'icons8-enter_filled',
  error: 'icons8-attention_filled',
  priceBuilder: 'icons8-estimate_filled',
  event: 'icons8_calendar-filled',
  expand: 'plus_math',
  expandUp: 'icons8-double_up',
  expandDown: 'icons8-double_down',
  expand2Up: 'icons8-chevron_up_filled',
  expand2Down: 'icons8-chevron_down_filled',
  expand3Right: 'icons8-chevron_right_filled',
  expand3Down: 'icons8-chevron_down_filled',
  expired: 'expired',
  expiring: 'expiring',
  export: 'icons8-ms_excel_filled',
  exportToPdf: 'icons8-pdf_2',
  exportToPdfFilled: 'icons8-pdf_2_filled',
  field: 'icons8-price_tag',
  fieldActive: 'icons8-align_right',
  filter: 'icons8-filter_filled',
  fillDown: 'icons8-right_down2_filled',
  fitExpand: 'icons8-fit_to_width_filled',
  fitContract: 'icons8-collect_filled',
  fixCapitalization: 'icons8-sentence_case_filled',
  folder: 'icons8-folder',
  folderActive: 'icons8-opened_folder_filled',
  folderCollapsed: 'expand_right',
  folderExpanded: 'expand_down',
  folderFilled: 'folder_filled',
  form: 'icons8-test_partial_passed_filled',
  grab: 'grab',
  googleDrive: 'google-drive',
  help: 'icons8-help',
  helpFilled: 'icons8-help_filled',
  hint: 'icons8-help_filled',
  history: 'clock_filled',
  homeCompany: 'home_filled',
  hubspot: 'sprocket_web_black',
  imageUpload: 'icons8-image-add',
  import: 'icons8-upload_to_cloud',
  info: 'info_filled',
  integrations: 'disconnected',
  invisible: 'icons8-hide',
  invoice: 'money_transfer',
  invoiceSent: 'icons8-sent_filled',
  invoiceMarkPosted: 'checkmark',
  jobBoard: 'icons8-factory',
  kashflow: 'kashflow',
  keyboardShortcuts: 'icons8-keyboard_filled',
  lastSeen: 'icons8-clock_filled',
  live: 'icons8-ok_filled',
  logo: 'logo_notext',
  loading: 'loading',
  latestActivity: 'icons8-view_shedule',
  latestActivityFilled: 'icons8-view_shedule_filled',
  mail: 'icons8-mailbox_closed_flag_down_filled',
  manager: 'icons8-manager_filled',
  margin: 'calculator',
  marketing: 'icons8-open_envelope',
  markup: 'calculator',
  markAsDormant: 'icons8-delete_user_male_filled',
  marker: 'marker_filled',
  mastercard: 'icons8-mastercard',
  mobile: 'icons8-touchscreen_smartphone_filled',
  more: 'icons8-menu_2_filled',
  move: 'icons8-move_filled',
  movePurchaseOrder: 'icons8-data_transfer',
  moveQuote: 'icons8-data_transfer',
  moveStock: 'move_stock',
  moveStockFilled: 'icons8-move_stock_filled',
  navigateDown: 'arrowDown',
  navigateRight: 'arrowForward',
  navigateLeft: 'arrowBack',
  navigateLeftBold: 'icons8-chevron_left_filled',
  noAccess: 'icons8-cancel_2_filled',
  nominalCode: 'icons8-sales_performance_filled',
  note: 'note_filled',
  notAccepted: 'signature_filled',
  notIncluded: 'icons8-cancel',
  notifications: 'appointment_reminders_filled',
  notificationsEmpty: 'appointment_reminders',
  opportunity: 'cheap_2',
  options: 'menu_2_filled',
  optInOut: 'icons8-stop_sign_filled',
  order: 'handshake',
  orderItem: 'bill_filled',
  orderType: 'handshake',
  orderReason: 'handshake',
  part: 'icons8-cardboard_box_filled',
  partCategory: 'icons8-folder_invoices_filled',
  partCode: 'icons8-cancel_4_digits_filled',
  password: 'icons8-password',
  paste: 'icons8-paste_filled',
  pastel: 'money_transfer', // TODO
  percentage: 'icons8-percentage',
  phone: 'icons8-phone_filled',
  pin: 'icons8-pin',
  pinFilled: 'icons8-pin_filled',
  pivotTableGutterExpanded: 'pivotTableGutterExpanded',
  pivotTableGutterContracted: 'pivotTableGutterContracted',
  playFilled: 'play_filled',
  preview: 'search',
  priceBuilderTasks: 'icons8-parallel_tasks_filled',   //'priceBuilder',
  priceList: 'icons8-price_tag_usd_filled',
  pricingCalculator: 'calculator',
  pricingTemplate: 'icons8-stacked_organizational_chart_highlighted_first_node_filled',
  priorityHigh: 'icons8-high_priority_filled',
  priorityMedium: 'icons8-medium_priority_filled',
  priorityLow: 'icons8-low_priority_filled',
  print: 'print',
  printTemplate: 'document_filled',
  production: 'factory',
  productionDepartment: 'factory',
  productionWorkCentre: 'icons8-robot',
  productionWorkCentreFilled: 'icons8-robot_filled',
  product: 'product_filled',
  purchaseOrder: 'icons8-shopping_cart',
  purchaseOrderFilled: 'icons8-shopping_cart_filled',
  purchasing: 'icons8-shopping_cart',
  purchasingFilled: 'icons8-shopping_cart_filled',
  quickBooks: 'quickbooks',
  quoteAcceptance: 'signature_filled',
  receivedData: 'icons8-incoming_data_filled',
  recent: 'clock_filled',
  refresh: 'refresh_filled',
  rejected: 'icons8-cancel_2_filled',
  rejectedActivity: 'icons8-test_failed',
  rejectedActivityFilled: 'icons8-test_failed_filled',
  rental: 'icons8-borrow_book_filled',
  reorder: 'grab',
  requiredSoon: 'required_soon',
  revert: 'icons8-undo_filled',
  revision: 'revision',
  replyArrow: 'replyArrow',
  sage: 'sage',
  scale: 'icons8-scale',
  scaleFilled: 'icons8-scale_filled',
  sales: 'cheap_2',
  save: 'save_filled',
  saveAs: 'icons8-save_as',
  search: 'search',
  selectArrow: 'select_arrow',
  sentData: 'icons8-outgoing_data_filled',
  settings: 'icons8-settings_filled',
  size: 'icons8-surface_filled',
  signatureFilled: 'signature_filled',
  skill: 'icons8-student_male_filled',
  snowman: 'icons8-snowman',
  star: 'filled_star',
  stockLevel: 'icons8-move_by_trolley_filled',
  supportChat: 'icons8-communication_filled',
  supplier: 'icons8-supplier',
  supplierFilled: 'icons8-supplier_filled',
  taxCode: 'accounting_filled',
  templates: 'icons8-template',
  templatesFilled: 'icons8-template_filled',
  team: 'icons8-door_opened',
  teamFilled: 'icons8-door_opened_filled',
  tick: 'checkmark',
  tickFrilly: 'icons8-approval_filled',
  trendUp: 'icons8-up_arrow',
  trendDown: 'icons8-down_arrow',
  trendEqual: 'icons8-approximately_equal_filled',
  time: 'time',
  unPin: 'icons8-unpin',
  unPinFilled: 'icons8-unpin_filled',
  unsent: 'unsent',
  unconfirmed: 'unconfirmed',
  upgrade: 'icons8-shopping_cart_filled',
  upload: 'upload_filled',
  userAdmin: 'under_computer_filled',
  user: 'icons8-user_male_circle_filled',
  users: 'icons8-user_account',
  tagSTRING: 'icons8-lowercase_filled',
  tagMEMO: 'icons8-lowercase_filled',
  tagNUMBER: 'icons8-42_filled',
  tagCURRENCY: 'icons8-banknotes_filled',
  tagBOOLEAN: 'icons8-light_switch_filled',
  tagDATETIME: 'icons8-tear_off_calendar_filled',
  tagLIST: 'icons8-test_partial_passed_filled',
  tagMULTI_LIST: 'icons8-test_passed_filled',
  thread: 'icons8-link_filled',
  updateChange: 'right_filled',
  unchecked: 'icons8-unchecked_circle_filled',
  version: 'icons8-software_installer_filled',
  versionHistory: 'history',
  view: 'icons8-visible_filled',
  visa: 'icons8-visa',
  visible: 'icons8-visible_filled',
  wizards: 'icons8-witch',
  wizardsFilled: 'icons8-witch_filled',
  warning: 'icons8-error_filled',
  website: 'icons8-domain_filled',
  undo: 'icons8-undo',
  xero: 'xero',
  zoho: 'zoho',

  restoreDefaultView: 'icons8-collapse-50',
  maximise: 'icons8-expand-50',
  commentAdded: 'comment',
  material: 'material',
  labour: 'icons8-worker_filled',
  resource: 'icons8-hammer_filled',
  outsourced: 'icons8-client_management_filled',
  nonStock: 'icons8-ungroup_objects_filled',
  timesheet: 'icons8-time_filled',
  expenses: 'icons8-general_ledger_filled',
  assembly: 'icons8-parallel_tasks_filled',
  service: 'icons8-customer_support',
  laptop: 'icons8-laptop-and-phone',
  // ..add more icons here
}
